import { Component } from 'js-component-framework';

export default class TopicsNav extends Component {
  static clickHandler(event, showElems, hideElems) {
    event.preventDefault();
    event.stopPropagation();
    showElems.forEach((elem) => {
      elem.classList.remove('hidden');
    });
    hideElems.forEach((elem) => {
      elem.classList.add('hidden');
    });
  }

  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
  }

  init() {
    const {
      controller,
      closeButton,
      openButton,
      target,
    } = this.children;

    if (! controller || ! target) {
      return;
    }

    target.classList.add('hidden');

    closeButton.addEventListener('click', (e) => TopicsNav
      .clickHandler(e, [openButton], [closeButton, target]));

    openButton.addEventListener('click', (e) => TopicsNav
      .clickHandler(e, [closeButton, target], [openButton]));
  }
}
